import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type EventDetails } from '~entities/events/index';
import { invalidateSessionLinkedCounts } from '~entities/session/api/get-class-event-count-session-by-id';

import { baseAPI } from '~shared/api/base-api';

interface DeleteEventParams {
  eventId: string;
}

export const deleteEventAPI = async (params: DeleteEventParams) => {
  const response = await baseAPI.delete<EventDetails>(
    `/events/${params.eventId}`,
  );
  return response.data;
};

export const useDeleteEvent = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: DeleteEventParams) => deleteEventAPI(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['events'] });
      void invalidateSessionLinkedCounts(queryClient);
    },
  });
};
